<div class="panel-container" [class.panel-wide]="isWidePanel">
  <div class="sidebar-header">
    <div class="flex flex-row items-center gap-2">
      <h2>{{panelDetails?.title}}</h2>
      <i *ngIf="panelDetails?.infoNotes?.length"
        class="fa-solid fa-info-circle cursor-pointer"
        style="color: #4663ae; font-size: 16px;"
        title="What do these rows mean?"
        (click)="toggleInfoNotes()"></i>
    </div>

    <h2 class="sidebar-close" (click)="closed.emit(false)">&times;</h2>
  </div>
  <div *ngIf="showInfoNotes && panelDetails?.infoNotes?.length" class="info-notes">
    <ul>
      <li *ngFor="let note of panelDetails?.infoNotes">{{ note }}</li>
    </ul>
  </div>
  <div *ngIf="reasonCounts.length" class="reason-counts">
    <span *ngFor="let rc of reasonCounts" class="reason-count-chip">
      {{ rc.label }}: <strong>{{ rc.count }}</strong>
    </span>
  </div>
  <div *ngIf="!!panelDetails.filterDetails" class="flex flex-row px-4 py-2 gap-2 items-end justify-end">
    <img src="/assets/filter.svg" (click)="isShowFilters()">
  </div>
  <ng-container *ngIf="showFilters && !!panelDetails.filterDetails">
    <app-side-panel-filter
      [displayFilters]="panelDetails.filterDetails"
      [alertType]="panelDetails.alertType"
      [existingFilterData]="panelDetails.alertFilters"
      >
    </app-side-panel-filter>
  </ng-container>
  <div class="overflow-y-scroll pl-2">
    <ng-container *ngIf="!!panelDetails.headerSection">
      <app-side-panel-table-data
      [rowData]="panelDetails?.panelDetails"
      [headerDetails]="panelDetails.headerSection">
      </app-side-panel-table-data>
    </ng-container>
    <ng-container *ngIf="panelDetails.discrepancies">
      <app-discrepancies
      [discrepancies]="panelDetails.discrepancies"
      ></app-discrepancies>
    </ng-container>
    <ng-container *ngIf="panelDetails.signaturedata">
      <app-mdsignature
      [rowData]="panelDetails.signaturedata"
      >
      </app-mdsignature>
    </ng-container>
  </div>
  <ng-container *ngIf="panelDetails.footerMessage">
    <div class="px-4 py-3 text-sm text-gray-600 border-t">
      {{ panelDetails.footerMessage }}
    </div>
  </ng-container>
</div>